import { exec } from "jadelet"
export default exec(["div",{"id":["modal"]},[]])